<template>
  <div class="partner__carousel-container" :style="`--partners-carousel-speed: ${this.speed}ms`">
    <div class="partner__carousel" v-for="i in 2" :key="i">
      <PartnerCard
        v-for="(partner, partnerIndex) in partners"
        :content="partner"
        :key="partnerIndex"
      />
    </div>
  </div>
</template>

<script>
import PartnerCard from '@/components/cards/PartnerCard.vue'

export default {
  name: 'MobilePartnersCarousel',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    PartnerCard,
  },
  data() {
    return {
      partners: [...this.content.items.research, ...this.content.items.partner],
      speed: 10000,
    }
  },
}
</script>
